import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PrimaryButton from '../Button/PrimaryButton';
import { DIALOG_TONES, tonedActionButtonSx, tonedDialogPaperSx } from './dialogTones';

const Modal = ({
  open,
  setModalClose,
  title,
  size,
  isBackdrop = false,
  className,
  closeButton = true,
  contentTitle,
  contentText,
  backButtonText,
  backButtonFunc,
  saveButtonText,
  saveButtonFunc,
  loading,
  tone,
  icon,
  ...rest
}) => {
  const toneColors = tone ? DIALOG_TONES[tone] : null;
  const handleClose = () => {
    setModalClose(false);
  };
  return (
    <Dialog
      className={className}
      {...rest}
      fullWidth
      maxWidth={size || 'xs'}
      open={open}
      onClose={isBackdrop ? () => {} : handleClose}
      sx={toneColors ? tonedDialogPaperSx(toneColors) : undefined}>
      {toneColors ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.75,
            px: 3,
            pt: 3,
            pb: 0.5,
            bgcolor: toneColors.surface,
            borderBottom: `1px solid ${toneColors.border}`,
          }}>
          {icon && (
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: toneColors.iconBg,
                color: toneColors.accent,
                flexShrink: 0,
                '& .MuiSvgIcon-root': { fontSize: 22 },
              }}>
              {icon}
            </Box>
          )}
          <Box sx={{ flex: 1, minWidth: 0, pb: 2.5 }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: 18,
                fontWeight: 600,
                letterSpacing: '-0.01em',
                color: '#2F2F2F',
                lineHeight: 1.35,
              }}>
              {contentTitle}
            </Typography>
            <Typography
              sx={{
                mt: 0.75,
                fontSize: 14,
                fontWeight: 400,
                color: '#6A6A6A',
                lineHeight: 1.55,
              }}>
              {contentText}
            </Typography>
          </Box>
          {closeButton && (
            <IconButton size="small" onClick={handleClose} aria-label="close" sx={{ color: '#8A8A8A', mt: -0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      ) : (
        <Grid container>
          <Grid item xs={10}>
            {title && <DialogTitle>{title}</DialogTitle>}
          </Grid>
          <Grid item xs={2} textAlign={'right'}>
            {closeButton && (
              <div className="closeButton">
                <IconButton size="small" color="default" className="deleteButton" onClick={handleClose} aria-label="edit">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
            )}
          </Grid>
        </Grid>
      )}
      <DialogContent sx={toneColors ? { px: 3, pt: 2.5, pb: 2.5 } : undefined}>
        <Grid container spacing={2}>
          {!toneColors && (
            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{
                  mb: 1,
                  fontSize: 24,
                  fontWeight: 600,
                  color: '#333333',
                }}>
                {contentTitle}
              </Typography>
              <Typography
                sx={{
                  mb: 5,
                  fontSize: 14,
                  fontWeight: 400,
                  color: '#555555',
                  lineHeight: 1.5,
                }}>
                {contentText}
              </Typography>
            </Grid>
          )}
          <Grid item xs={6} className={'pt-0'}>
            <PrimaryButton
              variant="outlined"
              onClick={backButtonFunc}
              sx={
                toneColors
                  ? {
                      borderColor: '#D6D6D6',
                      color: '#5A5A5A',
                      backgroundColor: '#fff',
                      boxShadow: 'none',
                      textTransform: 'none',
                      fontWeight: 500,
                      '&:hover': {
                        borderColor: '#C0C0C0',
                        backgroundColor: '#FAFAFA',
                      },
                    }
                  : undefined
              }>
              {backButtonText}
            </PrimaryButton>
          </Grid>
          <Grid item xs={6} className={'pt-0'}>
            <PrimaryButton
              disabled={loading}
              onClick={saveButtonFunc}
              sx={toneColors ? tonedActionButtonSx(toneColors) : undefined}>
              {saveButtonText}
            </PrimaryButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
